export const PANEL_AREA_SOURCE_NAV_MODES = {
  STRUCTURE: "structure",
  CONTENT: "content",
};

export const PANEL_AREA_SOURCE_NAV_MODES_LABELS = {
  [PANEL_AREA_SOURCE_NAV_MODES.STRUCTURE]: "structure",
  [PANEL_AREA_SOURCE_NAV_MODES.CONTENT]: "content",
};
